<template>
  <div class="result-error-root" :class="{ foot, isMobileScan }">
    <h3 class="error-title" v-html="$t('result.scan_unsuccessful')"></h3>
    <h3 class="my-3 md:my-5 text-center text-xs md:text-base mt-auto">
      {{ $t('result.avoid_errors') }}
    </h3>
    <div class="flex flex-row flex-wrap md:flex-no-wrap items-center justify-center mb-auto">
      <template v-if="foot">
        <div class="error-item foot">
          <img src="../../assets/Error/error-floor.svg" alt="" />
          <span>{{ $t('result.error_floor_marks') }}</span>
        </div>
      </template>
      <template v-else-if="isMobileScan">
        <div class="error-item">
          <img src="../../assets/Error/error-neck.svg" alt="" />
          <span>{{ $t('result.error_cover_neck') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-postural.svg" alt="" />
          <span>{{ $t('result.error_postural') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-not-inscreen.svg" alt="" />
          <span>{{ $t('mobileScan.error_not_inscreen') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-messy-background.svg" alt="" />
          <span>{{ $t('mobileScan.error_messy_background') }}</span>
        </div>
      </template>
      <template v-else>
        <div class="error-item">
          <img src="../../assets/Error/error-accessories.svg" alt="" />
          <span>{{ $t('result.error_accessories') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-neck.svg" alt="" />
          <span>{{ $t('result.error_cover_neck') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-floor.svg" alt="" />
          <span>{{ $t('result.error_floor_marks') }}</span>
        </div>
        <div class="error-item">
          <img src="../../assets/Error/error-postural.svg" alt="" />
          <span>{{ $t('result.error_postural') }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: {
    foot: Boolean,
    manual: Boolean,
    isMobileScan: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.result-error-root {
  @apply py-4 flex flex-1 flex-col;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  color: #2c2c2c;
  &.foot {
    @apply w-full;
    background-color: rgb(243, 243, 243);
    .error-title {
      @apply mb-4;
    }
    .error-item {
      @apply w-full;
      img {
        @apply my-5;
      }
      span {
        @apply text-sm my-6;
      }
    }
  }
  &.isMobileScan {
    .error-item {
      min-height: 120px;
      img {
        @apply w-2/5;
      }
      span {
        @apply my-2 w-11/12 inline-block;
      }
    }
  }
}
.error-title {
  @apply text-base text-center mx-auto;
  @screen md {
    @apply text-2xl;
  }
  font-weight: 600;
  line-height: 1.46;
  max-width: 80%;
}
.error-item {
  @apply text-xs w-1/2 text-center my-1;
  @screen md {
    @apply text-sm my-3;
    line-height: 3.33;
    img {
      @apply w-40;
    }
  }
  img {
    @apply w-1/2 mx-auto max-w-xs;
  }
}
</style>
